var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CModal,
    {
      attrs: {
        title: "Missing Fonts",
        size: "lg",
        "ok-title": "Import Design",
        value: _vm.isOpen,
      },
      on: { close: _setup.onClose },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "d-flex justify-content-end w-100" },
                [
                  _c(
                    "b-overlay",
                    {
                      staticClass: "d-inline-block ml-2",
                      attrs: {
                        show: _vm.isLoading,
                        rounded: "",
                        opacity: "0.6",
                        "spinner-small": "",
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { disabled: _vm.isLoading },
                          on: { click: _setup.onConfirm },
                        },
                        [_vm._v("Import Design")]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", { staticClass: "fonts-not-found-warning" }, [
        _c(
          "div",
          { staticClass: "notification-message mb-1 mr-2" },
          [
            _c("font-awesome-icon", {
              staticClass: "mr-2",
              attrs: { icon: ["fas", "triangle-exclamation"] },
            }),
            _vm._v(
              "\n            We couldn’t match these fonts to your Customily library. Pick the closest match from your available\n            fonts, you’ll be able to upload your own later if needed.\n        "
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-10px" }, [
        _c("div", { staticClass: "col-6 text-bold fs-1rem" }, [
          _vm._v("Missing Font"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6 text-bold fs-1rem" }, [
          _vm._v("Replacement"),
        ]),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _vm._l(_setup.fontsReplaced.entries(), function ([index, font]) {
        return _c("div", { key: `font-${index}`, staticClass: "row mt-10px" }, [
          _c(
            "div",
            {
              staticClass:
                "col-6 d-flex justify-content-between align-items-center",
            },
            [
              _c("span", { staticClass: "text-bold" }, [
                _vm._v(_vm._s(font.fontReplaced)),
              ]),
              _vm._v(" "),
              _c("font-awesome-icon", {
                staticClass: "color-gray",
                attrs: { icon: ["fas", "arrow-right"], size: "lg" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c(_setup.FontSelector, {
                attrs: {
                  "append-to-body": "",
                  label: "",
                  "show-font-upload": false,
                  value: _setup.toCSelectItem(font.userFont),
                },
                on: {
                  input: function ($event) {
                    return _setup.onFontChange(index, $event)
                  },
                },
              }),
            ],
            1
          ),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }